import XlsxUploadCard from "./XlsxUploadCard";

/**
 * Facturación Seminuevos upload card. Uses the same XLSX schema as the
 * new-car sales file but posts to a dedicated endpoint that tags each
 * row with `data_source='seminuevos'` and forces the `showroom` to fold
 * under the canonical "Seminuevos" branch. Replace mode purges only
 * seminuevos rows (leaving the new-car data untouched).
 */
export default function SeminuevosUploadCard({ onUploaded }) {
  return (
    <XlsxUploadCard
      kind="sales_seminuevos"
      endpoint="/admin/sales-seminuevos/upload-xlsx"
      title="Facturación Seminuevos"
      description={
        <>
          Sube el archivo <strong>Data Facturacion Seminuevos.xlsx</strong>{" "}
          (sheet &quot;Export&quot;). Se almacena junto a las ventas nuevas
          pero etiquetado como Seminuevos y aparece como sucursal aparte en
          el Scorecard y el Forecast.
        </>
      }
      resultKeys={{
        insertedLabel: "Insertadas",
        updatedLabel: "Actualizadas",
        totalKey: "total_seminuevos_after",
        totalLabel: "Total Seminuevos",
      }}
      testid="seminuevos-upload-card"
      showModeSelector
      defaultMode="replace"
      onUploaded={onUploaded}
    />
  );
}
